// extracted by mini-css-extract-plugin
export var videoHero = "_bq-4";
export var videoHeroImage = "_bq-5";
export var videoHeroOverlay = "_bq-6";
export var videoHeroSubtitle = "_bq-8";
export var videoHeroText = "_bq-7";
export var videoLauncher = "_bq-0";
export var videoLauncherIcon = "_bq-1";
export var videoLauncherSubtitle = "_bq-3";
export var videoLauncherTitle = "_bq-2";
export var videoPlayer = "_bq-a";
export var videoPlayerWrap = "_bq-9";